import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

 connect(userId, userType) {
  // ✅ If socket exists, reuse it
  if (this.socket) {
    if (this.socket.connected) {
      console.log("⚠️ Socket already connected");
      return this.socket;
    }

    console.log("🔄 Reconnecting existing socket...");
    this.socket.connect();
    return this.socket;
  }

  console.log("🚀 Creating new socket...", userId, userType);

  this.socket = io(SOCKET_URL, {
    auth: {
      token: localStorage.getItem('token'),
      userId,
      userType
    },
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000
  });

  // ✅ Attach core listeners ONCE
  this.socket.on('connect', () => {
    console.log('🟢 Socket connected:', this.socket.id);

    // Join rooms
    this.socket.emit('join-room', `user:${userId}`);
    this.socket.emit('join-room', `role:${userType}`);
  });

  this.socket.on('disconnect', (reason) => {
    console.log('🔴 Socket disconnected:', reason);
  });

  this.socket.on('connect_error', (error) => {
    console.error('❌ Socket connection error:', error);
  });

  this.socket.on('error', (error) => {
    console.error('❌ Socket error:', error);
  });

  return this.socket;
}

  disconnect() {
  if (this.socket) {
    console.log("🛑 Disconnecting socket...");

    this.socket.removeAllListeners(); // ✅ prevent memory leaks
    this.socket.disconnect();

    this.socket = null;
    this.listeners.clear();
  }
}

  // Subscribe to an event
 on(event, callback) {
  if (!this.socket) {
    console.warn('Socket not connected. Call connect() first.');
    return;
  }

  // ✅ Prevent duplicate listener
  this.socket.off(event, callback);

  if (!this.listeners.has(event)) {
    this.listeners.set(event, new Set());
  }

  this.listeners.get(event).add(callback);
  this.socket.on(event, callback);
}

  // Unsubscribe from an event
  off(event, callback) {
    if (!this.socket) return;

    if (callback) {
      // Remove specific callback
      this.socket.off(event, callback);
      this.listeners.get(event)?.delete(callback);
    } else {
      // Remove all callbacks for this event
      this.socket.removeAllListeners(event);
      this.listeners.delete(event);
    }
  }

  // Emit an event
  emit(event, data) {
    if (!this.socket) {
      console.warn('Socket not connected. Call connect() first.');
      return;
    }
    this.socket.emit(event, data);
  }

  // Get connection status
  isConnected() {
    return this.socket?.connected || false;
  }

  // Get socket ID
  getSocketId() {
    return this.socket?.id;
  }
}

const socketService = new SocketService();

export default socketService;